import { render, staticRenderFns } from "./LastContactedDisplay.vue?vue&type=template&id=1540495a&scoped=true&"
import script from "./LastContactedDisplay.vue?vue&type=script&lang=js&"
export * from "./LastContactedDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LastContactedDisplay.vue?vue&type=style&index=0&id=1540495a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540495a",
  null
  
)

export default component.exports